import { magic } from '@gig/magic-sdk';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const FAQ_NAMESPACE = "FAQ_NAMESPACE";
const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
const SET_CATEGORIES = "SET_CATEGORIES";
const SET_ENTRIES = "SET_ENTRIES";
const SET_IS_LOADING = "SET_IS_LOADING";
const SET_CATEGORIES_LANGUAGE = "SET_CATEGORIES_LANGUAGE";
const SET_ENTRIES_LANGUAGE = "SET_ENTRIES_LANGUAGE";
const faqGetters = {
  searchText(state) {
    return state.searchText;
  },
  categories(state) {
    return state.categories;
  },
  entries(state) {
    return state.entries;
  },
  isLoading(state) {
    return state.isLoading;
  }
};
const faqActions = {
  setSearchText({ commit }, text) {
    commit(SET_SEARCH_TEXT, text);
  },
  fetchCategories(_0, _1) {
    return __async(this, arguments, function* ({ commit, getters, state }, lang) {
      if (getters.isLoading) {
        return;
      }
      if (getters.categories.length && state.categoriesLanguage === lang) {
        return;
      }
      commit(SET_IS_LOADING, true);
      commit(SET_CATEGORIES_LANGUAGE, lang);
      const categories = yield magic.methods.faqsCategories.get(lang);
      commit(SET_CATEGORIES, categories);
      commit(SET_IS_LOADING, false);
    });
  },
  fetchEntries(_0, _1) {
    return __async(this, arguments, function* ({ commit, getters, state }, lang) {
      if (getters.isLoading) {
        return;
      }
      if (getters.entries.length && state.entriesLanguage === lang) {
        return;
      }
      commit(SET_IS_LOADING, true);
      commit(SET_ENTRIES_LANGUAGE, lang);
      const entries = yield magic.methods.faqs.get(lang);
      commit(SET_ENTRIES, entries);
      commit(SET_IS_LOADING, false);
    });
  }
};
const faq = {
  namespaced: true,
  state: {
    searchText: "",
    categories: [],
    entries: [],
    isLoading: false,
    entriesLanguage: null,
    categoriesLanguage: null
  },
  getters: faqGetters,
  actions: faqActions,
  mutations: {
    [SET_SEARCH_TEXT](state, text) {
      state.searchText = text;
    },
    [SET_CATEGORIES](state, categories) {
      state.categories = categories;
    },
    [SET_ENTRIES](state, entries) {
      state.entries = entries;
    },
    [SET_IS_LOADING](state, isLoading) {
      state.isLoading = isLoading;
    },
    [SET_CATEGORIES_LANGUAGE](state, language) {
      state.categoriesLanguage = language;
    },
    [SET_ENTRIES_LANGUAGE](state, language) {
      state.entriesLanguage = language;
    }
  }
};

export { FAQ_NAMESPACE, faq, faqActions, faqGetters };
